var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "reject-application-modal",
        title: "Please confirm",
        centered: "",
        "ok-title": "Confirm",
        "ok-variant": "success",
      },
      on: { ok: _vm.confirmReject },
    },
    [
      _c("h4", [_vm._v("You are going to reject this application")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Reason of Rejection" } },
        [
          _c("b-form-textarea", {
            attrs: { rows: "6" },
            model: {
              value: _vm.formData.reason,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "reason", $$v)
              },
              expression: "formData.reason",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }